// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
export var setRovoChatProduct = function setRovoChatProduct(product) {
  if (window) {
    window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
  }
};